import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import './_Ul.scss';

/**
 * A ul element component which wraps a HTML ul and adds to it the basic bootstrap css rules.
 * All arbitrary DOM properties and attributes (including event handlers) are accepted and passed to HTML ul element.
 */
const Ul = props => {
  const { className, children, innerRef, ...rest } = props;
  const classes = classNames('B360Ul', className);
  return (
    <ul className={classes} ref={innerRef} {...rest}>
      {children}
    </ul>
  );
};

Ul.propTypes = {
  /**
   * A custom className for the component
   */
  className: PropTypes.string,
  /**
   * The component's children
   */
  children: PropTypes.node,
  /**
   * a ref handled by the native html element
   */
  innerRef: PropTypes.func
};

export default Ul;
